// frontend/src/pages/InvitacionesPage.jsx
import React from 'react';
import InvitacionesManager from '../components/InvitacionesManager';

const InvitacionesPage = () => {
  return (
    <div className="page-container">
      <InvitacionesManager />
    </div>
  );
};

export default InvitacionesPage;